<template>
  <span class="tag is-primary">
    {{ filter.label }}: {{ value }}&nbsp;
    <button class="delete is-small" @click="dropFilter" />
  </span>
</template>

<script>
import isObject from 'lodash/isObject';

export default {
  props: {
    filter: Object,
  },
  computed: {
    value() {
      const { value, type, title } = this.filter;

      if (isObject(value)) {
        if (['range', 'date_range'].includes(type)) {
          return `${value.start} - ${value.end}`;
        }

        if (type === 'search') {
          return `${value.title}`;
        }
      }

      if (type === 'boolean') {
        return value === 'true' ? 'Nαί' : 'Όχι';
      }

      if (title === 'gender') {
        return value === 'male' ? 'Άνδρας' : 'Γυναίκα';
      }

      return value;
    },
  },
  methods: {
    dropFilter() {
      this.$emit('dropFilter', this.filter.title);
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  margin-right: 0.5rem;
}
</style>
